export const SUPPLIER_MAPPING_TABLE_COLUMNS = [
  {
    key: 'sku',
    label: 'SKU',
    headerStyle: 'min-w-175px',
    isSorted: true,
  },
  {
    key: 'product_name',
    label: 'Product Name',
    headerStyle: 'min-w-450px',
    isSorted: true,
  },
  {
    key: 'brand_name',
    label: 'Brand',
    headerStyle: 'min-w-175px',
    isSorted: true,
  },
  {
    key: 'action',
    label: 'Action',
    headerStyle: 'w-80px',
  },
]

export const SUPPLIER_MAPPING_DEFAULT_VALUES = (isEdit: boolean, supplierMapping: any): any => ({
  userName: isEdit ? supplierMapping?.name : '',
  emailId: isEdit ? supplierMapping?.emailId : '',
  product_ids: isEdit && Array.isArray(supplierMapping?.products) ? supplierMapping.products : [],
})
